/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
    Box,
    CircularProgress,
    CircularProgressLabel,
    useMediaQuery
} from '@chakra-ui/react'
import { media } from 'components/utils/breakpoints'
import React, { ReactElement } from 'react'
import { StepItemProps, StepsProps } from './interfaces'
import { StepsList } from './styles'

export const Steps: React.FC<StepsProps> = ({
    currentStep,
    untilStep = 0,
    short = 'md',
    children,
    ...props
}) => {
    const childrenCurrent = children as ReactElement[]
    const [isShort] = useMediaQuery(media(short, 'max'))

    return (
        <>
            <StepsList
                data-testid="Step"
                as="ul"
                fontSize={isShort ? 'lg' : 'sm'}
                {...props}
            >
                {isShort ? (
                    <>
                        <li aria-current="step" aria-disabled="false">
                            <span>
                                {
                                    childrenCurrent[currentStep].props[
                                        'aria-label'
                                    ]
                                }
                            </span>
                        </li>
                        <CircularProgress
                            ml="auto"
                            mr={4}
                            value={(currentStep / childrenCurrent.length) * 100}
                            color="white"
                            trackColor="primary.500"
                        >
                            <CircularProgressLabel>
                                {`${currentStep} / ${childrenCurrent.length}`}
                            </CircularProgressLabel>
                        </CircularProgress>
                    </>
                ) : (
                    childrenCurrent?.map((element, i) => {
                        const index = i + 1
                        const isSelectPrevItem = untilStep >= index
                        return (
                            <li
                                {...element.props}
                                data-testid={`Step-item-${index}`}
                                key={i}
                                aria-current="step"
                                aria-disabled={!(currentStep === index)}
                                style={{
                                    opacity: currentStep >= index ? '1' : '0.7'
                                }}
                                tabIndex={isSelectPrevItem ? 1 : -1}
                                role={isSelectPrevItem ? 'button' : 'listitem'}
                                aria-pressed={
                                    isSelectPrevItem ? 'true' : 'false'
                                }
                            >
                                <span>{element.props['aria-label']}</span>
                            </li>
                        )
                    })
                )}
            </StepsList>
            {childrenCurrent?.map((element, i) => {
                const index = i + 1
                // delete element.props
                if (currentStep === index) {
                    return element
                }
            })}
        </>
    )
}

export const StepItem: React.FC<StepItemProps> = ({ children, ...props }) => (
    <Box {...props}>{children}</Box>
)
